import { GetterTree } from 'vuex';
import { RootState } from '@/store/index';
import { InsurersReportsState } from '@/store/modules/insurers-reports/index';
import {
  INSURERS_REPORTS_LIST,
  INSURERS_REPORTS_ERRORS,
  INSURERS_REPORTS_LOADING,
} from '@/types/insurers-reports.types';
import { Grid } from '@/models/Grid.model';
import { InsurersReportModel } from '@/models/backoffice/InsurersReportModel';

export const getters: GetterTree<InsurersReportsState, RootState> = {

  [INSURERS_REPORTS_ERRORS](state): string[] {
    return state.insurersReportsErrors;
  },

  [INSURERS_REPORTS_LOADING](state): boolean {
    return state.insurersReportsLoading;
  },

  [INSURERS_REPORTS_LIST](state): Grid<InsurersReportModel> {
    return state.insurersReportsList;
  },
};
